import { postRequest } from "../../httpClient";


export async function loadPresignedUrls(token, resourceKeys) {
    return await postRequest(`/v3/users/resources/presign`, token, resourceKeys)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}

